import { ComplainController } from "@/app/core/base/controllers/ComplainController";
import EditProfileModal from "@/app/core/layouts/main-components/account/EditProfileModal";
import { Autocomplete } from "@/app/core/util/helpers/AutocompleteHelper";
import Storage from "@/app/core/util/Storage";
import React, { useEffect, useState } from "react";
import ComplainItem from "./components/ComplainItem";

export default function Profile() {
    const [userData, setUserData] = useState(Storage.getUserData());
    const [data, setData] = useState([])
    const [raw, setRaw] = useState([])
    const [selected, setSelected] = useState({})
    const [showModal, setShowModal] = useState(false)

    useEffect(()=>{
        loadMyComplains()
    },[])
    
    async function loadMyComplains(){
        console.log("userData", userData);
        let results = await ComplainController.ListByUser(userData.uid);
        results.sort(function (a, b) {
            return b.createdDate.seconds - a.createdDate.seconds;
        });

        setData(results || []);
        setRaw(results || []);
        console.log("results", results)
        if(results && results.length > 0){
            setSelected(results[0]);
        }
    }

    function filterOptions(evt){
        setData(Autocomplete(evt.target.value, raw, ["title", "description"]))
    }

    return (
        <div>
            {userData && userData.uid ? 
                <div className="block-content border block-bordered block-content-sm block-content-full bg-white">
                    <div className="media py-3">
                        <div className="mr-3 ml-2 overlay-container overlay-right">
                            <img className="img-avatar img-avatar48" src={`${userData && userData.picture ? userData.picture : "assets/media/avatars/avatar4.jpg"}`} alt="" />
                        </div>
                        <div className="media-body">
                            <div className="row">
                                <div className="col-sm-7">
                                    <a className="font-w600 link-fx" href="be_pages_generic_profile.html">{userData && userData.name}</a>
                                    <div className="font-size-sm text-muted">{userData && userData.email}</div>
                                </div>
                                <div className="col-sm-5 d-sm-flex align-items-sm-center">
                                    <div className="font-size-sm font-italic text-muted text-sm-right w-100 mt-2 mt-sm-0">
                                        <button type="button" className="btn btn-hero-warning text-dark" onClick={() => setShowModal(true)}>
                                            Editar conta
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            : ""}
            <div className="row no-gutters flex-md-10-auto">
                <div className="col-md-4 col-lg-5 col-xl-3">
                    <div className="content">
                        <div className="d-md-none push">
                            <button type="button" className="btn btn-block btn-hero-primary" data-toggle="class-toggle" data-target="#side-content" data-className="d-none">
                                Inbox Menu
                            </button>
                        </div>

                        <div id="side-content" className="d-none d-md-block push">
                            <a type="button" className="btn btn-block btn-hero-warning text-dark mb-3" href="#/reclamar">
                                <i className="fa fa-plus mr-1"></i> Nova reclamação
                            </a>

                            <form action="be_pages_generic_inbox.html" method="post" onsubmit="return false;">
                                <div className="form-group">
                                    <div className="input-group">
                                        <input type="text" className="form-control border-0" placeholder="Filtrar..." onChange={evt => filterOptions(evt)}/>
                                        <div className="input-group-append">
                                            <span className="input-group-text border-0 bg-white">
                                                <i className="fa fa-fw fa-search"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </form>

                            <div className="list-group font-size-sm">
                                {data && data.map(item => (
                                    <a className={`list-group-item list-group-item-action border border-${item && item.orderId && item.orderStatus == "paid"? "success" : item && item.orderId && item.orderStatus == "pending" ? "info" : "danger" }`} href="javascript:void(0)" onClick={() => setSelected(item)}>
                                        <span className="badge badge-pill badge-dark m-1 float-right">3</span>
                                        <p className="font-size-h6 font-w700 mb-0">
                                            {item.title}
                                        </p>
                                        <p className="text-muted mb-2">
                                            {item.description}
                                        </p>
                                        <p className="font-size-sm text-muted mb-0">
                                            {/* <strong>{item.createdDate}</strong> */}
                                        </p>
                                    </a>
                                ))}

                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-8 col-lg-7 col-xl-9 bg-body-dark">
                    <div className="content">
                        {/* <!-- Message --> */}
                        {selected && selected.id ?                        
                            <ComplainItem item={selected} reload={() => loadMyComplains()}/>
                        :""}
                    </div>
                </div>
            </div>
            <EditProfileModal
                show={showModal}
                onHide={()=> setShowModal(false)}
            />
        </div>
    )
}